import React from 'react';
import { Form, Input, Select, Button } from 'antd';

const { Option } = Select;

const InviteeRegistrationForm = ({ config, onSubmit, initialValues = {} }) => {
  const [form] = Form.useForm();

  const renderField = (field) => {
    switch (field.type) {
      case 'text':
        return <Input placeholder={field.placeholder} />;
      case 'email':
        return <Input type="email" placeholder={field.placeholder} />;
      case 'select':
        return (
          <Select placeholder={field.placeholder}>
            {field.options &&
              field.options.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
          </Select>
        );
      default:
        return <Input placeholder={field.placeholder} />;
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={(values) => {
        onSubmit(values);
        form.resetFields();
      }}
    >
      {config.map((field, index) => (
        <Form.Item
          key={index}
          label={field.label}
          name={field.name}
          rules={[
            { required: field.required, message: field.message || `${field.label} is required` },
          ]}
        >
          {renderField(field)}
        </Form.Item>
      ))}
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Complete Registration
        </Button>
      </Form.Item>
    </Form>
  );
};

export default InviteeRegistrationForm;